/*
 * Clamps the PDP description to two lines and adds a "Ver más" / "Ver menos"
 * toggle, per the 2026-09 PDP mockup. The button only appears when the text
 * actually overflows, so short descriptions stay untouched.
 */
if (!customElements.get('product-description-toggle')) {
  customElements.define(
    'product-description-toggle',
    class ProductDescriptionToggle extends HTMLElement {
      connectedCallback() {
        this.text = this.querySelector('[data-description-text]');
        if (!this.text) return;

        this.button = document.createElement('button');
        this.button.type = 'button';
        this.button.className = 'product-description-toggle__btn';
        this.button.addEventListener('click', () => this.toggle());
        this.appendChild(this.button);

        this.open = false;
        this.render();

        // Fonts and a narrowing viewport both change how many lines the text
        // takes, so the overflow test has to re-run rather than be done once.
        this.onResize = FoxTheme.utils.debounce(() => this.render(), 150);
        window.addEventListener('resize', this.onResize);
        document.fonts?.ready.then(() => this.render());
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
      }

      toggle() {
        this.open = !this.open;
        this.render();
      }

      get overflows() {
        // Measured with the clamp off, so it reports whether the full text is
        // taller than the clamped box — not whether it is currently clipped.
        const clamped = this.classList.contains('is-open');
        this.classList.add('is-open');
        const full = this.text.scrollHeight;
        if (!clamped) this.classList.remove('is-open');
        return full - this.clampedHeight > 1;
      }

      get clampedHeight() {
        const styles = getComputedStyle(this.text);
        const lineHeight = parseFloat(styles.lineHeight) || parseFloat(styles.fontSize) * 1.72;
        return lineHeight * 2;
      }

      render() {
        this.classList.toggle('is-open', this.open);

        const needed = this.open || this.overflows;
        this.button.hidden = !needed;
        this.classList.toggle('is-clamped', needed && !this.open);
        this.button.textContent = this.open ? this.dataset.less : this.dataset.more;
        this.button.setAttribute('aria-expanded', this.open ? 'true' : 'false');
      }
    }
  );
}
